import { useEffect, useCallback } from 'react'
import InlineSVG from 'svg-inline-react';
import { MapSvg } from './SvgJs/map-source';
import { FILTERS } from './constants/filters';

const Map = ({ listToDisplay, extendCard, selectedPlace, mapInitialised, filters }) => {

    useEffect(() => {
        bindCircleEvent()
    })

    const displaySelectedCircles = useCallback(() => {
        const isChasseAuxSaveurs = filters === FILTERS.CHASSE_AUX_SAVEURS;
        let VirtualMap = Array.from(document.querySelectorAll("#map-vector #LEGENDES g"));
        VirtualMap.map((group, index) => {
            const isPlaceInList = listToDisplay.some(place => `place-${place["map-id"]}` === group.id);
            const isParkingGroup = group.id.startsWith('place-parking-');

            // Parkings : visibles sauf sur Chasse aux saveurs
            if (isParkingGroup) {
                if (isChasseAuxSaveurs) {
                    group.classList.remove('visible');
                } else {
                    group.classList.add('visible');
                }
            } else if (isPlaceInList) {
                group.classList.add('visible');
            } else {
                group.classList.remove('visible');
            }

            if (index === (VirtualMap.length - 1)) {
                mapInitialised()
            }
            return null;
        })
    }, [listToDisplay, mapInitialised, filters])

    useEffect(() => {
        displaySelectedCircles();
    }, [displaySelectedCircles])

    const extend = useCallback((object) => {
        if (object.length === 0) {
            let allCircles = document.querySelectorAll('#map-vector #LEGENDES g circle');
            Array.from(allCircles).forEach(circle => circle.classList.remove('selected'));
        } else {
            object = "place-" + object[0]["map-id"];
            let selectedCircle = document.querySelectorAll(`#map-vector #LEGENDES g#${object} circle`);
            let allCircles = document.querySelectorAll('#map-vector #LEGENDES g circle');
            Array.from(allCircles).forEach(circle => circle.classList.remove('selected'));
            if (selectedCircle.length > 0) {
                selectedCircle[0].classList.add('selected');
            } else {
                console.warn(`No circle found for ${object}`);
            }
        }
    }, [])

    const bindCircleEvent = useCallback(() => {
        let groupMapArray = Array.from(document.querySelectorAll("#map-vector #LEGENDES g"));
        groupMapArray.forEach(group => {
            if (group.id.startsWith('place-parking-')) {
                // Aucune interaction sur les parkings
                group.onclick = null;
                group.ontouchstart = null;
                group.style.cursor = 'default';
                group.style.pointerEvents = 'none';
                return;
            }
            group.style.cursor = 'pointer';
            group.style.pointerEvents = '';
            group.onclick = () => extendCard(group.id);
            group.ontouchstart = () => extendCard(group.id);
        })
    }, [extendCard])

    useEffect(() => {
        extend(selectedPlace)
    }, [extend, selectedPlace])

    return (
        <InlineSVG src={MapSvg} className="map" />
    )
}

export default Map